export default "__VITE_ASSET__hu6FoWCF__"